import script from "./OrderbuddyApp.vue?vue&type=script&lang=ts&setup=true"
export * from "./OrderbuddyApp.vue?vue&type=script&lang=ts&setup=true"

import "./OrderbuddyApp.vue?vue&type=style&index=0&id=1edc3693&lang=scss"

const __exports__ = script;

export default __exports__